import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/seo';
import Footer from '../components/Footer';
import HeaderMain from '../components/HeaderMain';
import HeroSingle from '../components/pages/HeroSingle';
import '../styles/app.scss';

const Membership = ({ data }) => {
    const { wordpressPage: post } = data;

    const test_title = post.yoast_title;
    const new_seo_title = test_title.replace('&#039;', "'");

    return (
        <>
            <SEO
                title={new_seo_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />
            <section className="smallestwdt memberships display_none">
                <div
                    className=""
                    dangerouslySetInnerHTML={{
                        __html: post.content,
                    }}
                />
            </section>
            <div className="smallestwdt memberships">
               
                <div className="margin-padding_div"></div>
                <div className="first_div-style">
                    <h2>Rockstar Memberships</h2>
                    <p className='first_div-style-para' style={{ textAlign:'center', color: '#146fb8', fontFamily: 'gothamblack', marginBottom: '15px' }}>Join the Fun with We Rock Memberships! </p>
                    <p className='first_div-style-para' style={{ textAlign: 'center', marginBottom: '15px' }}>Enjoy <strong>unlimited indoor play</strong>, <strong>exclusive discounts on camps</strong>, <strong>drop-off care</strong>, <strong>classes</strong>, and <strong>special events—</strong>all in a safe, inclusive <strong>sensory gym</strong> designed for <strong>children of all abilities</strong>. With <strong>flexible monthly plans</strong>, <strong>no long-term</strong> commitment, and <strong>member perks</strong> like <strong>snacks</strong> and <strong>guest passes</strong>, our memberships offer <strong>unbeatable value</strong> for families. </p>
                    <p className='first_div-style-para' style={{ textAlign: 'center' }}>Ready to rock? Explore our membership options below! Need more info? Our{' '}
  <a href="/frequently-asked-questions/" target="_blank" rel="noopener" style={{ color: '#146fb8', fontFamily: 'gothamblack' }}>
    FAQ section
  </a>{' '}
  has all the answers to help you rock your visit!</p>
                </div>
                <img className="linemar marg-liner mobs display_none" src="https://werockthespectrumatlantagym.wrtsfranchise.com/wp-content/uploads/2020/06/linefull.jpg" alt="linefull" />
                <h3 className='h3-hidden display_none'>Memberships</h3>

                <div className="main-flex_members display_none">
                    <div class="single-row_members"><div class="child_members first-child_members"></div><div class="child_members yell_floo">Rockstar</div><div class="child_members yell_floo">Rockstar Platinum</div></div>
                    <div class="single-row_members"><div class="child_members first-child_members yell_floo">Open Play</div><div class="child_members ">2 Hours Each Visit</div><div class="child_members ">Unlimited Open Play Each Visit</div></div>
                    <div class="single-row_members"><div class="child_members first-child_members yell_floo">Numbers of Visits</div><div class="child_members ">Unlimited</div><div class="child_members ">Unlimited</div></div>
                    <div class="single-row_members"><div class="child_members first-child_members yell_floo">Additional Class</div><div class="child_members ">10% Off Scheduled Classes*</div><div class="child_members ">10% Off Scheduled Classes*</div></div>
                    <div class="single-row_members"><div class="child_members first-child_members yell_floo">Kid Friendly Snack</div><div class="child_members ">-</div><div class="child_members ">Included</div></div>
                    <div class="single-row_members"><div class="child_members first-child_members yell_floo">Guest Pass</div><div class="child_members ">1 Guest Pass Each Month</div><div class="child_members ">1 Guest Pass Each Week</div></div>
                    <div class="single-row_members"><div class="child_members first-child_members yell_floo">Special Discounts</div><div class="child_members ">-</div><div class="child_members ">10% Off Rock Shop and Special Events*</div></div>
                </div>
                <p className='small_para stared display_none'>*Exclusions apply. Zumbini, Social Skills excluded.</p>
                <img className="linemar marg-liner" src="https://werockthespectrumatlantagym.wrtsfranchise.com/wp-content/uploads/2020/06/linefull.jpg" alt="linefull" />



                <div className="new-mg-bott"
                    dangerouslySetInnerHTML={{
                        __html: `<div class="elfsight-app-85d74316-d2ff-4e0c-86c0-3a260b024987" data-elfsight-app-lazy></div>`,
                    }}
                />

                <div className="main-flex_rockstars display_none">
                    <div className="column-flex_rockstars display_none">
                       
                        <h3>Daily Rockstar</h3>
                        <p>Get to know the Gym and our Class of the day<br />
                            Valid for 1 day only<br />
                            Kid Friendly Snack Included<br />
                            Free Wifi</p>
                        <h5>1 Child -  <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_daily,
                            }} 
                        /></h5>
                        <h5>2 Children - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_daily_two,
                            }}
                        /></h5>
                        <h5>3 Children - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_daily_three,
                            }}
                        /></h5>
                        
                            </div>
                            <div className="column-flex_rockstars">
                                <h3>Rockstar Platinum</h3>
                        <p>Unlimited Access to the gym<br />
                            Valid for 3 Months<br />
                            Kid Friendly Snack Included<br />
                            10% off Schedule Classes, Rock Shop, and Special Events<br />
                            1 Guest Pass Every Week<br />
                            Free Wifi</p>
                        <h5>1 Child - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_platinum_m_one,
                            }}
                        /> or <div
                                className="healwrap small_heals"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.healcode_platinum_w,
                                }}
                            /></h5>
                        <h5>2 Children - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_platinum_m_two,
                            }}
                        /> or <div
                                className="healwrap small_heals"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.healcode_platinum_w_two,
                                }}
                            /></h5>
                        <h5>3 Children - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_platinum_m_three,
                            }}
                        /> or <div
                                className="healwrap small_heals"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.healcode_platinum_w_three,
                                }}
                            /></h5>
                                
                                            </div>
                                            <div className="column-flex_rockstars">
                                                <h3>Rockstar</h3>
                        <p>Unlimited 2 Hour Drop-in's for Open Play each Month<br />
                            Valid for 3 Months<br />
                            1 Guest Pass Every Month<br />
                            Free Wifi</p>
                        <h5>1 Child - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_rockstar_m_one,
                            }}
                        /> or <div
                                className="healwrap small_heals"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.healcode_daily_w,
                                }}
                            /></h5>
                        <h5>2 Children - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_rockstar_m_two,
                            }}
                        /> or <div
                                className="healwrap small_heals"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.healcode_w_two_copy,
                                }}
                            /></h5>
                        <h5>3 Children - <div
                            className="healwrap small_heals"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.healcode_rockstar_m_three,
                            }}
                        /> or <div
                                className="healwrap small_heals"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.healcode_rock_w_three,
                                }}
                            /></h5>
                                               
                                                    </div>
                                                </div>

                                                    <section className="whywelist page-section bg-primary text-white" id="openpbasic">
                                                        <div class="container flexwrap whywebluelist">
                        <div class="section_memberships whylistrgt flexbox toup"><h2 className="yellowtxt">MEMBERSHIP BENEFITS</h2>
                                                                <ul class="startxt normalfontlist">
                                                                    <li>Unlimited Open Play Visits - Enjoy 2-Hour or Unlimited Play depending on your membership level. </li>
                                                                    <li>Bring a Friend or Cousin - Share the fun! Some memberships include weekly or monthly guest passes. </li>
                                                                    <li>Kid-Friendly Snack - Select memberships include 1 snack per visit. </li>
                                                                    <li>Discounts on classes, camps, special events, parents night out, retail and birthday parties</li>
                                                                    <li>Free Scheduled Classes - Join us for Social Skills, Music, Arts & Crafts, Dance, STEAM and more. <a href="/classes/" target="_blank" rel="noopener noreferrer">Check the latest class schedule here.</a></li>
                                                                    <li>Parent Supervision Required - A parent or guardian must accompany the child during each visit.</li>
                                                                    <li>Socks Required for Adults - No shoes allowed on the gym floor. Socks available for purchase if needed. </li>
                                                                    <li>Flexible Monthly Plans - Memberships auto-renew each month and can be canceled anytime online or by phone, email, or chat. Please allow 48 hours for cancellation processing.</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </section>

                                                    <section className="page-section bg-secondary text-white centersec para_para">
                                                        <div className="container smallestwdt"><h2 class="yellowtxt">Open Play Day Passes & Packages</h2>
                                                            <p className="biggertxt"><p>Learn More about Open Play Drop-In and Passes <a href="/open-play/">Here</a>.</p>
                                                            </p></div>
                                                    </section>
               
            </div>


            <Footer />
        </>
    );
};
export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            content
            slug
            acf {
                healcode_daily
                healcode_daily_two
                healcode_daily_three
                healcode_daily_w
                healcode_w_two_copy
                healcode_rock_w_three
                healcode_rockstar_m_one
                healcode_rockstar_m_two
                healcode_rockstar_m_three
                healcode_platinum_w
                healcode_platinum_w_two
                healcode_platinum_w_three
                healcode_platinum_m_one
                healcode_platinum_m_two
                healcode_platinum_m_three
            }
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;

export default Membership;
